export default "__VITE_ASSET__Cn7ig6IN__"